<template>
    <div id="profile-page-outcall-area">
        <span class="profile-outcall-location-title">{{ translate.home.outCall }}</span>
        <span class="profile-outcall-location-info"
              v-if="user && user.escorts_profile && user.escorts_profile.outcall_location_info">
            {{ user.escorts_profile.outcall_location_info }}
        </span>

        <template v-if="user && user.outcall_locations_list && user.outcall_locations_list.length > 0">
            <span class="profile-outcall-location-subtitle">
                {{ translate.account.availableInFollowingAreas }}
            </span>

            <div class="profile-outcall-location-list">
                <span v-for="(location,index) in activeOutcallLocations"
                      :key="index"
                      class="profile-outcall-location-link"
                      :class="{'d-none d-md-inline': index >= 10 && !showAllLocations}">
                    <a :href="regionRelativeUrl(location.url || settings.defaultSearchUrl)" v-if="location.hasPublicUrl">
                        {{ getFirstLocationNamePart(location.name) + ((index === activeOutcallLocations.length - 1) ? '' : ',') }}
                    </a>
                    <template v-else>
                        {{ getFirstLocationNamePart(location.name) + ((index === activeOutcallLocations.length - 1) ? '' : ',') }}
                    </template>
                </span>

                <a href="javascript:void(0)"
                   class="profile-outcall-toggle-btn d-md-none"
                   v-if="activeOutcallLocations.length > 10"
                   @click="showAllLocations = !showAllLocations">
                    {{ showAllLocations ? translate.account.seeLess : translate.account.seeMore }}
                </a>
            </div>
        </template>
    </div>
</template>
<script>
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import userMixin from "@/components/mixins/userMixin";
import {isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";

function getFirstLocationNamePart(name) {
    return name.split(',')[0] || '';
}

export default {
    data() {
        return {
            showAllLocations: false,
        };
    },
    computed: {
        ...mapState(['translate', 'isSeekingServicesProfile', 'settings']),
        activeOutcallLocations() {
            const outcallLocations = _.get(this, 'user.outcall_locations_list', []);

            /** UK venues keep their full outcall list regardless of gold, matching nuxt */
            const showAllForUkVenue = isUnitedKingdomRegion() && this.isUserVenue(this.user);

            if (this.isGoldUser(this.user) || _.get(this, 'user.userCanHaveOutcallsForFree') || showAllForUkVenue) {
                return outcallLocations;
            }

            if (this.isSilverUser(this.user)) {
                return _.slice(outcallLocations, 0, this.settings.outcallLocations.maxSilverAmount);
            }

            return _.slice(outcallLocations, 0, this.settings.outcallLocations.maxFreeAmount);
        },
    },
    mixins: [userMixin, regionsUrlMixin],
    methods: {
        getFirstLocationNamePart,
    },
    props: ['user']
}
</script>
